module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-alert', {
    attrs: {
      "type": _vm.alertType,
      "transition": _vm.alertTransition,
      "outline": "",
      "dismissible": ""
    },
    model: {
      value: (_vm.alert),
      callback: function($$v) {
        _vm.alert = $$v
      },
      expression: "alert"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.alertText) + "\n  ")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2ce8092f","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/app/components/partials/Alerts.vue
// module id = 502
// module chunks = 0